import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function SectionCard({
  icon,
  title,
  subtitle,
  action,
  children,
  bodyClassName,
}: {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  bodyClassName?: string;
}) {
  return (
    <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-premium">
      <div className="border-b border-border px-5 py-3 flex items-center gap-3">
        <div className="size-9 bg-secondary border border-border rounded-xl flex items-center justify-center shrink-0 [&_svg]:!size-[22px]">
          {icon}
        </div>
        <div className="flex min-w-0 flex-col gap-0.5">
          <h3 className="text-base font-semibold text-foreground leading-5 -tracking-[0.2px]">
            {title}
          </h3>
          {subtitle && (
            <p className="truncate text-xs font-medium text-muted-foreground leading-4 -tracking-[0.2px]">
              {subtitle}
            </p>
          )}
        </div>
        {action && <div className="ml-auto shrink-0">{action}</div>}
      </div>
      <div className={cn('bg-secondary p-5', bodyClassName)}>{children}</div>
    </div>
  );
}
